import PageHero from "@/components/layout/PageHero";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS, formatDate } from "@/lib/insights";
import CTA from "@/components/sections/CTA";

export default function InsightsPage() {
    return (
        <div data-testid="page-insights">
            <PageHero
                title={<>Argument-led writing <em className="text-gold not-italic font-light">from the risk desk.</em></>}
                lead="Whitepapers, field notes, and events on Scope 3 as systemic risk, CBAM pricing, and the mechanics that turn climate into a P&amp;L line."
                image={INSIGHTS[0].hero}
            />

            <section className="relative py-16 lg:py-24 border-t border-navy/10">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                    <div className="border-t border-navy/10">
                        {INSIGHTS.map((item, i) => (
                            <motion.div
                                key={item.slug}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.6, delay: i * 0.05 }}
                                className="border-b border-navy/10"
                            >
                                <Link
                                    to={`/resources/${item.slug}`}
                                    className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 py-10 lg:py-14 hover:bg-white/40 transition-colors duration-500 px-2 lg:px-4"
                                    data-testid={`insights-row-${item.slug}`}
                                >
                                    <div className="lg:col-span-1 font-mono text-[10px] tracking-[0.24em] uppercase text-navy/40">
                                        / {String(i + 1).padStart(2, "0")}
                                    </div>
                                    <div className="lg:col-span-3 font-mono text-[10px] tracking-[0.24em] uppercase text-navy/50 flex flex-col gap-1">
                                        <span className="text-gold">{item.type}</span>
                                        <span className="text-navy/40">{item.readMinutes} min read</span>
                                    </div>
                                    <div className="lg:col-span-7">
                                        <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-[-0.02em] text-navy group-hover:text-gold transition-colors duration-500">
                                            {item.title}
                                        </h3>
                                        <p className="mt-4 text-navy/60 text-base lg:text-lg leading-relaxed max-w-[720px]">{item.subtitle}</p>
                                    </div>
                                    <div className="lg:col-span-1 flex lg:justify-end lg:items-start">
                                        <ArrowUpRight size={22} strokeWidth={1.2} className="text-navy/40 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
                                    </div>
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}
